import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

function ProtectedRoute({ children, roles }) {
  const authRaw = localStorage.getItem("auth");
  const location = useLocation();
  const auth = authRaw ? JSON.parse(authRaw) : null;

  if (!auth || !auth.token) {
    return <Navigate to="/authentication/sign-in" replace state={{ from: location }} />;
  }

  if (roles && Array.isArray(roles) && roles.length > 0) {
    const role = auth?.role;
    if (!role || !roles.includes(role)) {
      // redirect based on role
      const target = role === "AGENT" ? "/loyalty/agent/topup" : "/dashboard";
      return <Navigate to={target} replace />;
    }
  }
  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
};

ProtectedRoute.defaultProps = {
  roles: null,
};

export default ProtectedRoute;
